export const DASHBOARD_PANEL_DELETE_GADGET_OPEN_MODAL = "DASHBOARD_PANEL_DELETE_GADGET_OPEN_MODAL"
export const DASHBOARD_PANEL_DELETE_GADGET_REQUEST = "DASHBOARD_PANEL_DELETE_GADGET_REQUEST"
export const DASHBOARD_PANEL_DELETE_GADGET_RESULT = "DASHBOARD_PANEL_DELETE_GADGET_RESULT"